export interface SearchResultPage {
    application: string;
    application_slug: string;
    category: string;
    category_slug: string;
    id: string;
    name: string;
    slug: string;
    snippet: string;
    url: string;
}

export interface SearchResultApp {
    application: string;
    application_slug: string;
    categories: Array<SearchResultCategory>;
}

export interface SearchResultCategory {
    category: string;
    category_slug: string;
    pages: Array<SearchResultPage>;
}

export interface SearchResults {
    query: string;
    results: Array<SearchResultApp>;
}

export interface SearchSnippetPart {
    match: boolean;
    text: string;
}

export function escapeRegExp(regex: string) {
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
